import React, { useEffect, useState } from 'react'
import GoogleMapReact from 'google-map-react'
import { RiMapPinFill } from 'react-icons/ri'
const urlParams = new URLSearchParams((typeof window !== `undefined`) ? window.location.search : '')

export default function Home() {
  const [zoom, setZoom] = useState(13)
  const [booths, setBooths] = useState([])
  useEffect(() => {
    fetch(`https://cache.wizito.com/${urlParams.get('data')}`).then(res => res.json()).then(setBooths)
  }, [])
  return (
    <GoogleMapReact
      style={{ width: '100%', height: '100%' }}
      options={() => ({ mapId: 'cd6f778b2bebac00' })}
      bootstrapURLKeys={{ key: 'AIzaSyAVnzQlyDf5j9bbHjSqrXK4h8zTuFun22Q' }}
      defaultCenter={[48.86357325650093, 2.3391934812818396]}
      defaultZoom={13}
      onZoomAnimationEnd={z => setZoom(z)}
      yesIWantToUseGoogleMapApiInternals>
      {zoom > 12 && booths.map(booth =>
        <div
          key={booth.id}
          style={{
            width: 75,
            height: 40,
            transform: 'translate(-50%, -160%)'
          }}
          {...booth.coords}>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              boxShadow: '0 0 50px 50px rgba(255, 255, 255, .3)'
            }} />
          <div
            style={{
              position: 'relative',
              zIndex: 50,
              width: '100%',
              height: '100%',
              backgroundSize: 'contain',
              backgroundPosition: 'bottom center',
              backgroundRepeat: 'no-repeat',  
              backgroundImage: `url('${booth.logo}')`,
            }} />
        </div>
      )}
      {booths.map(booth =>
        <RiMapPinFill
          style={{ width: 25, height: 25, transform: 'translate(-50%, -100%)', color: '#001540' }}
          {...booth.coords} />
      )}
    </GoogleMapReact>
  )
}
